
import { ListDataSource } from "@/data/List/ListDataSource";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ModeratorSelector extends Vue {
  @Prop() moderator!: any;
  @Prop() personDataSource!: ListDataSource;
  @Prop({ default: "Не определено" }) notDefinedCaption!: string;
  @Prop() canEdit!: boolean;
  personId: any = null;

  editMode: boolean = false;

  get person() {
    console.log(
      this.personDataSource.items.find(
        (i: any) => i.id === this.dataSource.model.personId,
      ),
    );

    return this.personDataSource.items.find(
      (i: any) => i.id === this.dataSource.model.personId,
    );
  }

  dataSource: ObjectDataSource = new ObjectDataSource({
    className: "EventSessionModerator",
    id: this.moderator.id,
    model: this.moderator,
    config: {},
  });

  async update(personId) {
    await this.dataSource.updateField({
      fieldName: "personId",
      fieldValue: personId,
    });
    this.editMode = false;
  }
}
